import React from 'react'
import AddForm from '../../add-form'
import TopFold from '../../topfold'
import "./add-expense.css"
const AddExpense = () => {
  return (
   <div className='add-expense'>

<TopFold/>
<AddForm/>
   </div>

  )
}

export default AddExpense